import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { InputMaskField } from '@jutro/legacy/components';

const MIN_YEAR = 1900
const MAX_YEAR = 2100
const MIN_MONTH = 0
const MAX_MONTH = 11

// TODO: replace with MonthYearPicker component in Elysian
function MLMonthYearInput(props) {
    const {
        value,
        onValueChange, // prevent from overriding
        onBlur,
        ...rest
    } = props

    const parseValue = (val) => {
        if (val?.year && (val?.month || val.month === 0)) {
            const month = `00${val.month + 1}`.slice(-2); // months count from 0
            const year = `${val.year}0000`.slice(0,4);
            return `${month}${year}`
        }

        return ''
    };

    const [displayValue, setDisplayValue] = useState(parseValue(value))

    const constrain = (val, min, max) => Math.max(Math.min(max, val), min)

    const handleBlur = (event) => {
        const date = event.currentTarget.value.split('/')
        const month = parseInt(date[0])
        const year = parseInt(date[1])

        if (!year || (!month && month !== 0)) return onBlur(undefined)

        onBlur({
            year: constrain(year, MIN_YEAR, MAX_YEAR),
            month: constrain(month - 1, MIN_MONTH, MAX_MONTH), // months count from 0
            day: 1
        })
    }

    useEffect(() => {
        setDisplayValue(parseValue(value))
    }, [value, setDisplayValue])

    return <InputMaskField
        value={displayValue}
        placeholder="MM/YYYY"
        mask="99/9999"
        maskChar=" "
        onBlur={handleBlur}
        onValueChange={setDisplayValue}
        {...rest}
    />
}

MLMonthYearInput.propTypes = {
    value: {
        year: PropTypes.number,
        month: PropTypes.number,
        day: PropTypes.number,
    },
    onValueChange: PropTypes.func,
    onBlur: PropTypes.func,
    visible: PropTypes.bool,
    label: PropTypes.string
}

MLMonthYearInput.defaultProps = {
    value: '',
}

export default MLMonthYearInput